import React from "react";

export default function UslugiSelector(props) {
  let UslugaForm = (prop) => {
    const SetValue = (field, value) => {
      if (typeof value === "string") {
        let searchItem = null
        value = value.replaceAll('«', '"')
        value = value.replaceAll('»', '"')
        for (let i = 0; i < value.length; i++) {
          searchItem = value.indexOf('"')
          if (searchItem === -1) {
            break
          }
          if (searchItem + 1 !== value.length && value.charAt(searchItem+1)?.toLowerCase() !== value.charAt(searchItem+1)) {
            value = value.replace(/"/, '«')
          } else{
            value = value.replace(/"/, '»')
          }
  
        }
      }
      let newArray = [...props.value];
      newArray[prop.index].adv[5] = value;
      props.SetValue("uslugi", [...newArray]);
    };
    const SetValueName = (field, value) => {
      if (typeof value === "string") {
        let searchItem = null
        value = value.replaceAll('«', '"')
        value = value.replaceAll('»', '"')
        for (let i = 0; i < value.length; i++) {
          searchItem = value.indexOf('"')
          if (searchItem === -1) {
            break
          }
          if (searchItem + 1 !== value.length && value.charAt(searchItem+1)?.toLowerCase() !== value.charAt(searchItem+1)) {
            value = value.replace(/"/, '«')
          } else{
            value = value.replace(/"/, '»')
          }
  
        }
      }
      let newArray = [...props.value];
      newArray[prop.index].name = value;
      props.SetValue("uslugi", [...newArray]);
    };
      const SetFormValue = (field, value) => {
          let newArray = [...props.value];
          newArray[prop.index][field] = value;
          props.SetValue("uslugi", [...newArray]);
          props.SetValue(field, value);
      };
    const SetValueOther = (field, value) => {
      if (typeof value === "string") {
        let searchItem = null
        value = value.replaceAll('«', '"')
        value = value.replaceAll('»', '"')
        for (let i = 0; i < value.length; i++) {
          searchItem = value.indexOf('"')
          if (searchItem === -1) {
            break
          }
          if (searchItem + 1 !== value.length && value.charAt(searchItem+1)?.toLowerCase() !== value.charAt(searchItem+1)) {
            value = value.replace(/"/, '«')
          } else{
            value = value.replace(/"/, '»')
          }
  
        }
      }
      let newArray = [...props.value];
      newArray[prop.index].other = value;
      props.SetValue("uslugi", [...newArray]);
    };
    if (prop.type === "2") {
      return (
        <form action="#">
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[0] = !props.value[prop.index].adv[0];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[0]}
              />
              <span>Директор</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[1] = !props.value[prop.index].adv[1];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[1]}
              />
              <span>Адрес</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[2] = !props.value[prop.index].adv[2];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[2]}
              />
              <span>Состав участников</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[3] = !props.value[prop.index].adv[3];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[3]}
              />
              <span>ОКВЭД</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[4] = !props.value[prop.index].adv[4];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[4]}
              />
              <span>Размер УК</span>
            </label>
          </p>
          <div className="input">
            <label htmlFor={"otheru"}>{"Иное"}</label>
            <input
              value={props.value[prop.index].adv[5]}
              onChange={(e) => SetValue("", e.target.value)}
              onClick={() => SetValue("", prompt("Введите иную услугу"))}
              id={"otheru"}
              type={"text"}
            />
          </div>
        </form>
      );
    }
    if (prop.type === "3") {
      return (
        <div className="input">
          <label htmlFor={"usluga3name"}>{"Наименование"}</label>
          <input
            value={props.value[prop.index].name}
            onChange={(e) => SetValueName("", e.target.value)}
            onClick={() =>
              SetValueName("", prompt("Введите наименование"))
            }
            id={"usluga3name"}
            type={"text"}
          />
            <label htmlFor={"usluga3inn"}>{"ИНН"}</label>
            <input
                value={props.value[prop.index].inn}
                onChange={(e) => SetFormValue("inn", e.target.value)}
                onClick={() =>
                    SetFormValue("inn", prompt("Введите ИНН"))
                }
                id={"usluga3inn"}
                type={"text"}
            />
          <form action="#">
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[0] = !props.value[prop.index].adv[0];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[0]}
              />
              <span>Подготовка документов</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[1] = !props.value[prop.index].adv[1];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[1]}
              />
              <span>Подача/получение</span>
            </label>
          </p>
        </form>
        </div>
      );
    }
    if (prop.type === "4") {
      return (
        <div className="input">
          <form action="#">
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[0] = !props.value[prop.index].adv[0];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[0]}
              />
              <span>Подготовка док-ов на Ликвидацию</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[1] = !props.value[prop.index].adv[1];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[1]}
              />
              <span>Подача/получение док-ов на Ликвидацию</span>
            </label>
          </p>
          <p>
            <label>
              <input
                onChange={() => {
                  let newArray = [...props.value];
                  newArray[prop.index].adv[2] = !props.value[prop.index].adv[2];
                  props.SetValue("uslugi", [...newArray]);
                }}
                type="checkbox"
                class="filled-in"
                checked={props.value[prop.index].adv[2]}
              />
              <span>Получение справок</span>
            </label>
          </p>
        </form>
        </div>
      );
    }
    if (prop.type === "13") {
      return (
        <div className="input">
          <label htmlFor={"otherus"}>{"Наименование иной услуги"}</label>
          <input
            value={props.value[prop.index].other}
            onChange={(e) => SetValueOther("", e.target.value)}
            onClick={() =>
              SetValueOther("", prompt("Введите наименование иной услуги"))
            }
            id={"otherus"}
            type={"text"}
          />
        </div>
      );
    }
    return <div></div>;
  };
  return (
    <div>
      <p>Услуги</p>
      {props.value.map((elem, index) => {
        return (
          <div>
            <div className="input-field">
              <select
                className="browser-default"
                onChange={(e) => {
                  let newArray = [...props.value];
                  newArray[index] = { type: e.target.value };
                  if (e.target.value == "2") {
                    newArray[index] = {
                      type: e.target.value,
                      adv: [false, false, false, false, false, ""],
                    };
                  }
                  if (e.target.value == "3") {
                    newArray[index] = {
                      type: e.target.value,
                      adv: [false, false],
                      name: '',
                    };
                  }
                  if (e.target.value == "4") {
                    newArray[index] = {
                      type: e.target.value,
                      adv: [false, false, false],
                    };
                  }
                  if (e.target.value == "13") {
                    newArray[index] = {
                      type: e.target.value,
                      other: "",
                    };
                  }

                  if (props.value[index].type === "") {
                    newArray = [...newArray, { type: "" }];
                  }
                  if (
                    newArray.filter((element) => element.type === "").length > 1
                  ) {
                    newArray.splice(index, 1);
                  }
                  props.SetValue("uslugi", [...newArray]);
                }}
              >
                <option
                  value=""
                  selected={props.value[index].type == "" ? true : false}
                >{"Услуга "+(index+1).toString()}</option>
                <option
                  value="2"
                  selected={props.value[index].type == "2" ? true : false}
                >
                  Изменения
                </option>
                <option
                  value="3"
                  selected={props.value[index].type == "3" ? true : false}
                >
                  Первичка
                </option>
                <option
                  value="4"
                  selected={props.value[index].type == "4" ? true : false}
                >
                  Ликвидация
                </option>
                <option
                  value="7"
                  selected={props.value[index].type == "7" ? true : false}
                >
                  ЭЦП
                </option>
                <option
                  value="8"
                  selected={props.value[index].type == "8" ? true : false}
                >
                  Адрес
                </option>
                <option
                  value="9"
                  selected={props.value[index].type == "9" ? true : false}
                >
                  Представительство в банках и гос. органах
                </option>
                <option
                  value="10"
                  selected={props.value[index].type == "10" ? true : false}
                >
                  Консультация
                </option>
                <option
                  value="11"
                  selected={props.value[index].type == "11" ? true : false}
                >
                  Пробирка
                </option>
                <option
                  value="12"
                  selected={props.value[index].type == "12" ? true : false}
                >
                  Подача в налоговую
                </option>
                <option
                  value="13"
                  selected={props.value[index].type == "13" ? true : false}
                >
                  Иное
                </option>
              </select>
            </div>
            <UslugaForm type={elem.type} index={index} />
          </div>
        );
      })}
    </div>
  );
}
